export default {
  getPath(cv) {
    let path = `/customer/${cv.customerId}`;

    if (cv.currentConversationId) {
      path = `${path}/conversation/${cv.currentConversationId}`;
    }

    if (cv.currentConversationItemId) {
      path = `${path}/item/${cv.currentConversationItemId}`;
    }

    return path;
  },
};



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/url_converters/customer_view_url_converter.js